import { render, staticRenderFns } from "./MainCalendarGroupRoomStatusForm.vue?vue&type=template&id=585e7bbb&scoped=true&"
import script from "./MainCalendarGroupRoomStatusForm.vue?vue&type=script&lang=js&"
export * from "./MainCalendarGroupRoomStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585e7bbb",
  null
  
)

export default component.exports